import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_5123_11021)\"><path d=\"M15.3359 5.33301L15.3359 10.6663C15.3359 10.6663 15.3359 11.6663 14.3359 11.6663L1.66927 11.6663C1.66927 11.6663 0.66927 11.6663 0.66927 10.6663L0.66927 5.33301C0.66927 5.33301 0.669271 4.33301 1.66927 4.33301L14.3359 4.33301C14.3359 4.33301 15.3359 4.33301 15.3359 5.33301Z\" fill=\"currentColor\"></path><path d=\"M14.3359 1L14.3359 2C14.3359 2 14.3359 3 13.3359 3L2.66927 3C2.66927 3 1.66927 3 1.66927 2L1.66927 0.999999C1.66927 0.999999 1.66927 -5.53678e-07 2.66927 -5.09966e-07L13.3359 -4.37114e-08C13.3359 -4.37114e-08 14.3359 0 14.3359 1Z\" fill=\"currentColor\"></path><path d=\"M14.3359 14L14.3359 15C14.3359 15 14.3359 16 13.3359 16L2.66927 16C2.66927 16 1.66927 16 1.66927 15L1.66927 14C1.66927 14 1.66927 13 2.66927 13L13.3359 13C13.3359 13 14.3359 13 14.3359 14Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_5123_11021\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(16) rotate(90)\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gridIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
  size: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})